/**
 * Cajas de efectivo "blanco / N" — espejo de `server/src/lib/cajasEfectivo.ts`
 * (mantener iguales). El usuario elige la caja base ("Efectivo Pesos") y el
 * server la resuelve a la gemela "… N" cuando el cobro/pago no lleva factura.
 */

export const CAJAS_EFECTIVO_BASE = ['Efectivo Pesos', 'Efectivo Dolar'] as const;
const SUFIJO_N = ' N';

/** "Efectivo Pesos N" → "Efectivo Pesos"; cualquier otro nombre, igual. */
export function cajaBase(medio: string): string {
  const m = medio.trim();
  if (!m.endsWith(SUFIJO_N)) return m;
  const base = m.slice(0, -SUFIJO_N.length);
  return (CAJAS_EFECTIVO_BASE as readonly string[]).includes(base) ? base : m;
}

/** ¿Es una de las cajas de efectivo con par (base o N)? */
export function esCajaEfectivoConPar(medio: string): boolean {
  return (CAJAS_EFECTIVO_BASE as readonly string[]).includes(cajaBase(medio));
}

/** ¿Es la gemela "sin factura"? Se oculta de los selectores de Ventas y Compras. */
export function esCajaN(medio: string): boolean {
  const m = medio.trim();
  return esCajaEfectivoConPar(m) && m !== cajaBase(m);
}

/**
 * Nombre para mostrar donde NO hay ícono (Excel, mensajes, textos): la "N"
 * es un nombre interno y el cliente no la quiere ver. En pantalla, con ícono,
 * se usa `<CajaNombre>` (nombre base + ícono rojo).
 */
export function etiquetaCaja(medio: string): string {
  return esCajaN(medio) ? `${cajaBase(medio)} (sin factura)` : medio.trim();
}

/** La caja real donde el server va a asentar el cobro/pago. Sólo para avisarle al usuario. */
export function cajaEfectivoPara(medio: string, llevaFactura: boolean): string {
  if (!esCajaEfectivoConPar(medio)) return medio;
  const base = cajaBase(medio);
  return llevaFactura ? base : `${base}${SUFIJO_N}`;
}
